import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NbButtonModule} from "@nebular/theme";
import {Title} from "@angular/platform-browser";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-invite-members',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule
  ],
  templateUrl: './invite-members.component.html',
  styleUrl: './invite-members.component.scss'
})
export class InviteMembersComponent {
  teamId = '';
  currentTitle!: string;
  displayMessage = false;

  constructor(private readonly title: Title,private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.currentTitle = this.title.getTitle();
    this.teamId = this.route.snapshot.params['team_id'];
    this.displayMessage = this.route.snapshot.queryParams['confirm-account-message'];
  }

  copyToClipboard(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  invitationLink() {
    const baseUrl = this.removeLastSlash(window.location.origin);
    const path = this.removeFirstSlash(this.router.createUrlTree(['teams', this.teamId, 'player-registration']).toString());
    return `${baseUrl}/${path}`;
  }

  removeFirstSlash(input: string): string {
    return input.replace(/^\/+/, '');
  }

  removeLastSlash(input: string): string {
    return input.replace(/\/$/, '');
  }

}
